import * as React from "react";
const SvgChevronDown = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M12 12.5 16.5 8l2 2-6.5 6.5L5.5 10l2-2z" })));
export default SvgChevronDown;
//# sourceMappingURL=ChevronDown.js.map